/**
 * @desc 邮件帐号保存
 */
const URL = "/rantion-crm";
import http, { updateResponse } from "@/http";
export function request(body: defs.crm.MailMessageDto, options?: any) {
  return updateResponse(
    http(URL + `/rpc/mailMessage/save`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
